"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscriptionDocumentValidation = void 0;
const privateEquity_1 = require("./privateEquity");
function subscriptionDocumentValidation(subscription) {
    const products = subscription.productsSubscribed ?? [];
    const hasAnomaly = subscription.rtoDocumentsStatus === "anomalyReported" || products.some((product) => product.documentsValidatedStatus === "anomalyReported");
    const pendingRto = !(0, privateEquity_1.isPrivateEquityOnly)(products) && subscription.rtoDocumentsStatus !== "validated" && subscription.rtoDocumentsStatus !== "anomalyReported";
    const pendingProductIds = products
        .filter((product) => product.documentsValidatedStatus !== "validated" && product.documentsValidatedStatus !== "anomalyReported")
        .map((product) => product.id);
    return {
        hasAnomaly,
        pendingRto,
        pendingProductIds,
        allValidated: products.length > 0 && !hasAnomaly && !pendingRto && pendingProductIds.length === 0,
    };
}
exports.subscriptionDocumentValidation = subscriptionDocumentValidation;
